import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ContextService {
  private readonly CONTEXT_KEY = 'entryContext';

  setEntryContext(context: string): void {
    sessionStorage.setItem(this.CONTEXT_KEY, context);
  }

  getEntryContext(): string | null {
    return sessionStorage.getItem(this.CONTEXT_KEY);
  }
}
